const initialState = {
    anchor: 'left',
    usuario: [],
    open: false,
    id: '',
    login: '',
    listaDispositivos: [],
    listaFazendas: [],
    nome: '',
    senha: '',
    data_cadastro: '',
    usuario_cadastro: '',
    tipo: '',
    cpf: '',
    data_exclusao: '',
    usuario_exclusao: '',
    email: '',
    telefone: '',
    id_empresa: 0,
    id_prefeitura: 0,
    caminho_assinatura: '',
    observacoes: '',
    modulo_financeiro: false
};

export function usuario(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_USUARIO':
            return {
                ...state,
                usuario: action.usuario
            };
        case 'USUARIO_DETAIL':
            return {
                ...state,
                id: action.id,
                login: action.login,
                nome: action.nome,
                senha: action.senha,
                listaDispositivos: action.listaDispositivos,
                listaFazendas: action.listaFazendas,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                tipo: action.tipo,
                cpf: action.cpf,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                email: action.email,
                telefone: action.telefone,
                observacoes: action.observacoes,
                id_empresa: action.id_empresa,
                id_prefeitura: action.id_prefeitura,
                caminho_assinatura: action.caminho_assinatura,
                modulo_financeiro: action.modulo_financeiro
            };
        case 'USUARIO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                usuario: [],
                open: false,
                id: '',
                login: '',
                nome: '',
                senha: '',
                listaDispositivos: [],
                listaFazendas: [],
                data_cadastro: '',
                usuario_cadastro: '',
                tipo: '',
                cpf: '',
                data_exclusao: '',
                usuario_exclusao: '',
                email: '',
                telefone: '',
                observacoes: '',
                id_empresa: 0,
                id_prefeitura: 0,
                caminho_assinatura: '',
                modulo_financeiro: false
            };
        case "USUARIO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
